import { Paper, Stack, Typography, useTheme, Grid2 as Grid } from "@mui/material";
import { Order, OrderSourceIcons, PaymentMethodsIcons, PaymentMethodsLabels } from "@/types";
import { MENU_FLOW_LABELS, ORDER_SOURCE_LABELS } from "@/constants/global";
import { HugeiconsIcon } from "@hugeicons/react";
import { MapPinpoint01Icon, Scooter03Icon } from "@hugeicons/core-free-icons";
import { isEmpty } from "lodash";

interface OrderSummaryCardProps {
    label: string;
    value: string;
    icon: any;
}

const OrderSummaryCard = ({ label, value, icon }: OrderSummaryCardProps) => {
    const { palette } = useTheme();

    if (!icon) return null;

    return (
        <Paper sx={{ flex: 1, overflow: 'hidden' }} >
            <Stack px={2} py={3} alignItems="center" justifyContent="center" sx={{ backgroundColor: palette.primary.main }}>
                <HugeiconsIcon icon={icon} size={36} color="white" strokeWidth={1} />
            </Stack>
            <Stack p={2}>
                <Typography align="center" variant="caption" textTransform="uppercase" color="text.secondary">
                    {label}
                </Typography>
                <Typography align="center" variant="h4">
                    {value}
                </Typography>
            </Stack>
        </Paper>
    );
};

interface OrderSummaryProps {
    order: Order;
}

const OrderSummary = ({ order }: OrderSummaryProps) => {
    return (
        <Grid container spacing={2}>
            {!isEmpty(order?.flow) ? (
                <Grid size={{ xs: 6, md: 3 }}>
                    <OrderSummaryCard
                        label="Tipo"
                        value={MENU_FLOW_LABELS[order.flow as unknown as keyof typeof MENU_FLOW_LABELS]}
                        icon={Scooter03Icon}
                    />
                </Grid>
            ) : null}
            {order?.deliveryLocation?.distance?.text && order?.deliveryLocation?.duration?.text ? (
                <Grid size={{ xs: 6, md: 3 }}>
                    <OrderSummaryCard
                        label="Distancia"
                        value={`${order.deliveryLocation.distance.text} / ${order.deliveryLocation.duration.text}`}
                        icon={MapPinpoint01Icon}
                    />
                </Grid>
            ) : null}
            {!isEmpty(order?.paymentDetails?.method) ? (
                <Grid size={{ xs: 6, md: 3 }}>
                    <OrderSummaryCard
                        label="Pago"
                        value={PaymentMethodsLabels[order.paymentDetails?.method as keyof typeof PaymentMethodsLabels]}
                        icon={PaymentMethodsIcons[order.paymentDetails?.method as keyof typeof PaymentMethodsIcons]}
                    />
                </Grid>
            ) : null}
            {!isEmpty(order?.source) ? (
                <Grid size={{ xs: 6, md: 3 }}>
                    <OrderSummaryCard
                        label="Canal"
                        value={ORDER_SOURCE_LABELS[order.source as keyof typeof ORDER_SOURCE_LABELS]}
                        icon={OrderSourceIcons[order.source as keyof typeof OrderSourceIcons]}
                    />
                </Grid>
            ) : null}
        </Grid>
    );
};

export default OrderSummary;